import type { Fault } from "../domain/types";
import { countFaults, listBoards, putBoard, upsertFault } from "../storage/db";
import { SEED_BOARDS } from "./boards.seed";

// Pannes de bootstrap (domaine board) pour que l'app diagnostique dès la 1re
// ouverture, AVANT toute sync. Ids "seed-…" pour ne pas heurter les uuid du core ;
// la sync viendra ensuite enrichir/compléter depuis la base régionale.
const SEED_FAULTS: Fault[] = [
  {
    id: "seed-board-001",
    domaine: "board",
    device_brand: "Apple",
    device_model: null,
    symptom: "pas de démarrage, aucune consommation au branchement",
    source: "curated",
    updated_at: new Date().toISOString(),
    probable_causes: [
      { cause: "PPBUS_G3H absent (rail principal non établi)", weight: 0.6, procedure: "Vérifier PPBUS_G3H ; remonter vers MOSFETs et contrôleur de charge." },
      { cause: "Court-circuit sur PPBUS_G3H", weight: 0.5, procedure: "Mesure résistance PPBUS à GND ; injection douce pour localiser le composant chaud." },
      { cause: "SMC non alimenté (PP3V42_G3H absent)", weight: 0.4, procedure: "Contrôler PP3V42_G3H ; vérifier oscillateur et reset SMC." },
    ],
  },
  {
    id: "seed-board-002",
    domaine: "board",
    device_brand: "Apple",
    device_model: null,
    symptom: "consomme quelques mA puis s'éteint après une seconde",
    source: "curated",
    updated_at: new Date().toISOString(),
    probable_causes: [
      { cause: "Séquence d'allumage interrompue (rail SOC ne s'établit pas)", weight: 0.55, procedure: "Suivre la séquence power-on ; identifier le premier rail manquant." },
      { cause: "Court franc sur un rail core sollicité au boot", weight: 0.5, procedure: "Mesurer la résistance de chaque rail core à GND." },
    ],
  },
  {
    id: "seed-board-003",
    domaine: "board",
    device_brand: null,
    device_model: null,
    symptom: "voyant d'alimentation clignote et ne démarre pas",
    source: "curated",
    updated_at: new Date().toISOString(),
    probable_causes: [
      { cause: "Court-circuit sur le rail principal déclenchant la protection du chargeur", weight: 0.55, procedure: "Débrancher la batterie ; mesurer la résistance des rails à GND ; localiser le court." },
      { cause: "MOSFET de charge ou contrôleur de charge HS", weight: 0.4, procedure: "Vérifier les MOSFETs de l'étage de charge et le signal d'activation." },
    ],
  },
];

/** Charge les seeds en base la première fois (idempotent). */
export async function seedIfEmpty(): Promise<void> {
  if ((await listBoards()).length === 0) {
    for (const b of SEED_BOARDS) await putBoard(b);
  }
  if ((await countFaults()) === 0) {
    for (const f of SEED_FAULTS) await upsertFault(f);
  }
}
